import { createActionTypeModel } from "../../../../store/global/action-model";

export const DistributionSupplierOrderData = createActionTypeModel('DistributionSupplierOrderData');

export const DistributionSupplierOrderList = createActionTypeModel('DistributionSupplierOrderList');
export const DistributionSupplierOrderDetails = createActionTypeModel('DistributionSupplierOrderDetails');

export const SET_DISTRIBUTION_SUPPLIER_ORDER_FILES = 'SET_DISTRIBUTION_SUPPLIER_ORDER_FILES'


export const DistributionSupplierOrderSOrderLines = createActionTypeModel('DistributionSupplierOrderSOrderLines');

export const DistributionSupplierOrderSOProduct = createActionTypeModel('DistributionSupplierOrderSOProduct');

export const DistributionSupplierOrderOrderLines = createActionTypeModel('DistributionSupplierOrderOrderLines');

export const DistributionSupplierOrderSO = createActionTypeModel('DistributionSupplierOrderSO');

export const DistributionSupplierOrderBOrderLines = createActionTypeModel('DistributionSupplierOrderBOrderLines');